export const REQUIRED_ERROR_MESSAGE = 'Il campo è obbligatorio'
export const EMAIL_VALIDATION_ERROR_MESSAGE = 'Inserisci una mail valida'
export const USERNAME_VALIDATION_ERROR_MESSAGE =
    'Almeno 3 caratteri, massimo 20, può includere numeri, lettere e caratteri  _, .'
export const PASSWORD_VALIDATION_ERROR_MESSAGE =
    'La password deve essere lunga almeno 8 caratteri e contenere almeno una lettera ed un numero.'
